(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const easing = 'cubic-bezier(.25,.1,.25,1)';
  class AkHeader extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', e => {
        const open = e.target.closest('[data-ak-open]');
        if (open) { const dialog = document.getElementById(open.dataset.akOpen); if (dialog) this.openDialog(dialog, open); }
        if (e.target.closest('[data-ak-close]')) this.closeDialog(e.target.closest('dialog'));
        const summary = e.target.closest('[data-ak-menu] > summary');
        if (summary) {
          e.preventDefault();const detail = summary.parentElement;
          if(detail.open) this.closeMenu(detail); else {
            this.querySelectorAll('[data-ak-menu][open]').forEach(d => this.closeMenu(d));
            detail.open=true;summary.setAttribute('aria-expanded','true');
            detail.querySelector('.ak-menu-panel').animate([{opacity:0,transform:'translateY(-8px)'},{opacity:1,transform:'translateY(0)'}],{duration:reduced()?0:500,easing});
          }
        }
        if(e.target.closest('.ak-mobile-nav a')) this.closeDialog(e.target.closest('dialog'));
      },{signal});
      this.querySelectorAll('dialog').forEach(d => {
        d.addEventListener('cancel',e=>{e.preventDefault();this.closeDialog(d);},{signal});
        d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.closeDialog(d);}},{signal});
      });
      document.addEventListener('click',e=>{if(!this.contains(e.target))this.querySelectorAll('[data-ak-menu][open]').forEach(d=>this.closeMenu(d));},{signal});
      this.addEventListener('keydown',e=>{if(e.key==='Escape'){this.querySelectorAll('[data-ak-menu][open]').forEach(d=>{this.closeMenu(d);d.querySelector('summary').focus();});}},{signal});
      const onScroll=()=>this.classList.toggle('is-compact',window.scrollY>(this.classList.contains('is-compact')?12:90));
      window.addEventListener('scroll',onScroll,{passive:true,signal});onScroll();
    }
    async closeMenu(detail) {
      if(!detail.open||detail.dataset.closing)return;
      detail.dataset.closing='true';
      await detail.querySelector('.ak-menu-panel').animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-6px)'}],{duration:reduced()?0:220,easing}).finished.catch(()=>{});
      detail.open=false;delete detail.dataset.closing;detail.querySelector('summary').setAttribute('aria-expanded','false');
    }
    openDialog(dialog, opener) {
      if(dialog.open)return;
      this.querySelectorAll('[data-ak-menu][open]').forEach(d=>this.closeMenu(d));
      this.opener=opener;if(dialog.classList.contains('ak-search-dialog'))dialog.style.setProperty('--ak-search-top',`${Math.max(12,Math.round(this.getBoundingClientRect().bottom+12))}px`);dialog.showModal();document.body.classList.add('ak-lock');opener.setAttribute('aria-expanded','true');
      requestAnimationFrame(()=>requestAnimationFrame(()=>{dialog.classList.add('is-open');dialog.querySelector('input')?.focus({preventScroll:true});}));
    }
    async closeDialog(dialog) {
      if(!dialog?.open||dialog.dataset.closing)return;
      dialog.dataset.closing='true';dialog.classList.remove('is-open');
      await Promise.all(dialog.getAnimations().map(animation=>animation.finished.catch(()=>{})));
      if(!this.isConnected)return;
      dialog.close();delete dialog.dataset.closing;document.body.classList.remove('ak-lock');
      this.opener?.setAttribute('aria-expanded','false');this.opener?.focus({preventScroll:true});
    }
    disconnectedCallback(){this.controller?.abort();this.querySelectorAll('dialog[open]').forEach(d=>d.close());document.body.classList.remove('ak-lock');}
  }
  class AkBanner extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      this.slides=[...this.querySelectorAll('[data-ak-slide]')];this.index=0;
      this.addEventListener('click',e=>{const dot=e.target.closest('[data-ak-dot]');if(dot)this.show(Number(dot.dataset.akDot));if(e.target.closest('[data-ak-next]'))this.show(this.index+1);if(e.target.closest('[data-ak-prev]'))this.show(this.index-1);},{signal});
      const shell=this.querySelector('.ak-banner-shell');
      let gesture=null, suppressClickUntil=0;
      const clearGesture=()=>{
        if(gesture&&shell?.hasPointerCapture(gesture.id))shell.releasePointerCapture(gesture.id);
        gesture=null;shell?.classList.remove('is-swiping');
      };
      shell?.addEventListener('pointerdown',event=>{
        if(!event.isPrimary||event.button!==0||this.slides.length<2||event.target.closest('button,input,select,textarea'))return;
        gesture={id:event.pointerId,x:event.clientX,y:event.clientY,horizontal:false};
      },{signal});
      shell?.addEventListener('pointermove',event=>{
        if(!gesture||event.pointerId!==gesture.id)return;
        const x=event.clientX-gesture.x,y=event.clientY-gesture.y;
        if(!gesture.horizontal){
          if(Math.abs(y)>10&&Math.abs(y)>Math.abs(x)){clearGesture();return;}
          if(Math.abs(x)<12||Math.abs(x)<Math.abs(y)*1.25)return;
          gesture.horizontal=true;shell.setPointerCapture(event.pointerId);shell.classList.add('is-swiping');
        }
        if(event.cancelable)event.preventDefault();
      },{signal});
      shell?.addEventListener('pointerup',event=>{
        if(!gesture||event.pointerId!==gesture.id)return;
        const x=event.clientX-gesture.x,y=event.clientY-gesture.y;
        const threshold=Math.min(65,Math.max(35,shell.clientWidth*.12));
        if(gesture.horizontal){
          suppressClickUntil=performance.now()+500;
          if(Math.abs(x)>=threshold&&Math.abs(x)>Math.abs(y)*1.25)this.show(this.index+(x<0?1:-1));
        }
        clearGesture();
      },{signal});
      shell?.addEventListener('pointercancel',clearGesture,{signal});
      shell?.addEventListener('lostpointercapture',()=>{gesture=null;shell.classList.remove('is-swiping');},{signal});
      shell?.addEventListener('pointerleave',()=>{if(gesture&&!gesture.horizontal)clearGesture();},{signal});
      shell?.addEventListener('dragstart',event=>event.preventDefault(),{signal});
      shell?.addEventListener('click',event=>{
        if(performance.now()<suppressClickUntil){event.preventDefault();event.stopImmediatePropagation();suppressClickUntil=0;}
      },{capture:true,signal});
      document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0)this.show(i);},{signal});
    }
    show(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));});
      this.querySelectorAll('[data-ak-dot]').forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===this.index)));
      const status=this.querySelector('[data-ak-status]');
      if(status)status.textContent=`${this.index+1} / ${this.slides.length}: ${this.slides[this.index].querySelector('.ak-hero-title').textContent}`;
    }
    disconnectedCallback(){this.controller?.abort();}
  }
  class AkRooms extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      this.panels=[...this.querySelectorAll('[data-ak-room-panel]')];this.buttons=[...this.querySelectorAll('[data-ak-room]')];
      this.addEventListener('click',e=>{const b=e.target.closest('[data-ak-room]');if(b)this.show(Number(b.dataset.akRoom));},{signal});
      document.addEventListener('shopify:block:select',e=>{const i=this.buttons.findIndex(b=>b.dataset.blockId===e.detail.blockId);if(i>=0)this.show(i);},{signal});
    }
    show(index){this.buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));this.panels.forEach((p,i)=>{p.classList.toggle('is-active',i===index);p.inert=i!==index;p.setAttribute('aria-hidden',String(i!==index));});}
    disconnectedCallback(){this.controller?.abort();}
  }
  if(!customElements.get('ak-header'))customElements.define('ak-header',AkHeader);
  if(!customElements.get('ak-banner'))customElements.define('ak-banner',AkBanner);
  if(!customElements.get('ak-rooms'))customElements.define('ak-rooms',AkRooms);
  const motionQuery=matchMedia('(prefers-reduced-motion: reduce)');
  const pointerQuery=matchMedia('(hover: hover) and (pointer: fine)');
  const profiles=[
    {selector:'.ak-banner-shell',kind:'hero',x:16,y:11},
    {selector:'.ak-series-card, .akx-style, .ak-story-photo, .ak-room-picture',kind:'image',x:4,y:3},
    {selector:'.ak-pill',kind:'button',x:3,y:3}
  ];
  const tracked=new Map();
  const moving=new Set();
  const reveals=new Set();
  const revealAnimations=new Set();
  const seen=new WeakSet();
  let frame=0,lastTime=0;
  const enabled=()=>!motionQuery.matches&&pointerQuery.matches;
  const paint=state=>{
    state.element.style.setProperty('--ak-mx',`${(state.x*state.profile.x).toFixed(3)}px`);
    state.element.style.setProperty('--ak-my',`${(state.y*state.profile.y).toFixed(3)}px`);
    if(state.profile.kind==='hero'){
      state.element.style.setProperty('--ak-light-x',`${50+state.x*32}%`);
      state.element.style.setProperty('--ak-light-y',`${50+state.y*28}%`);
      state.element.style.setProperty('--ak-turn',`${(state.x*.55).toFixed(3)}deg`);
      state.element.style.setProperty('--ak-copy-x',`${(state.x*-2.5).toFixed(3)}px`);
      state.element.style.setProperty('--ak-copy-y',`${(state.y*-2).toFixed(3)}px`);
    }
  };
  const tick=time=>{
    frame=0;
    const dt=Math.min(40,lastTime?time-lastTime:16.67);
    lastTime=time;
    const factor=1-Math.exp(-dt/185);
    for(const state of moving){
      if(!state.element.isConnected){moving.delete(state);continue;}
      state.x+=(state.targetX-state.x)*factor;
      state.y+=(state.targetY-state.y)*factor;
      if(Math.abs(state.targetX-state.x)+Math.abs(state.targetY-state.y)<.001){
        state.x=state.targetX;state.y=state.targetY;moving.delete(state);
      }
      paint(state);
    }
    if(moving.size)frame=requestAnimationFrame(tick);else lastTime=0;
  };
  const schedule=state=>{
    moving.add(state);
    if(!frame)frame=requestAnimationFrame(tick);
  };
  const reset=(state,immediate=false)=>{
    state.targetX=state.targetY=0;state.rect=null;
    state.element.classList.remove('ak-pointer-active');
    if(immediate){state.x=state.y=0;moving.delete(state);paint(state);}else schedule(state);
  };
  const resetAll=()=>{
    tracked.forEach(state=>reset(state,true));
    cancelAnimationFrame(frame);frame=0;lastTime=0;
  };
  const attach=(element,profile)=>{
    if(tracked.has(element))return;
    const controller=new AbortController();
    const state={element,profile,controller,x:0,y:0,targetX:0,targetY:0,rect:null};
    tracked.set(element,state);element.dataset.akMotion=profile.kind;
    const move=event=>{
      if(!enabled()||event.pointerType!=='mouse')return;
      if(!state.rect)state.rect=element.getBoundingClientRect();
      const r=state.rect;
      if(!r.width||!r.height)return;
      state.targetX=Math.max(-1,Math.min(1,((event.clientX-r.left)/r.width-.5)*2));
      state.targetY=Math.max(-1,Math.min(1,((event.clientY-r.top)/r.height-.5)*2));
      element.classList.add('ak-pointer-active');schedule(state);
    };
    element.addEventListener('pointerenter',move,{signal:controller.signal,passive:true});
    element.addEventListener('pointermove',move,{signal:controller.signal,passive:true});
    element.addEventListener('pointerleave',()=>reset(state),{signal:controller.signal});
    element.addEventListener('pointercancel',()=>reset(state,true),{signal:controller.signal});
  };
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(({target,isIntersecting})=>{
      if(!isIntersecting)return;
      observer.unobserve(target);reveals.delete(target);
      if(reduced())return;
      const animation=target.animate([{opacity:.55,translate:'0 18px'},{opacity:1,translate:'0 0'}],{duration:650,easing});
      revealAnimations.add(animation);
      animation.finished.catch(()=>{}).finally(()=>revealAnimations.delete(animation));
    });
  },{threshold:.08}):null;
  const observe=(root=document)=>{
    profiles.forEach(profile=>root.querySelectorAll(profile.selector).forEach(element=>attach(element,profile)));
    root.querySelectorAll('[data-ak-reveal], .ak-section-heading, .akx-styles, .akx-size, .akx-origin, .akx-faq, .akx-concierge').forEach(element=>{
      if(seen.has(element))return;seen.add(element);
      if(!observer||reduced()||element.getBoundingClientRect().top<innerHeight)return;
      if(element.parentElement.closest('[data-ak-reveal]'))return;
      reveals.add(element);observer.observe(element);
    });
  };
  motionQuery.addEventListener('change',()=>{
    resetAll();
    if(reduced()){
      revealAnimations.forEach(animation=>animation.cancel());revealAnimations.clear();
      reveals.forEach(element=>observer?.unobserve(element));reveals.clear();
    }
  });
  pointerQuery.addEventListener('change',resetAll);
  window.addEventListener('blur',resetAll);
  window.addEventListener('resize',resetAll,{passive:true});
  window.addEventListener('scroll',()=>{tracked.forEach(state=>{if(state.rect)reset(state);});},{passive:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)resetAll();});
  document.addEventListener('shopify:section:load',event=>observe(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    tracked.forEach((state,element)=>{if(event.target.contains(element)){state.controller.abort();moving.delete(state);tracked.delete(element);}});
    reveals.forEach(element=>{if(event.target.contains(element)){observer?.unobserve(element);reveals.delete(element);}});
  });
  observe();
})();

